<script lang="ts">
  export let loading: Boolean;
</script>

{#if loading}
  <div class="lsr-loader" />
{/if}

<style lang="scss" global>
  $primary-color: #1565c0;

  .lrs-loader {
    display: block;
    height: 4px;
    margin-bottom: -4px;
    position: relative;
    overflow: hidden;
    background-color: rgba($primary-color, 0.08);

    &:before {
      content: "";
      position: absolute;
      display: block;
      left: -200px;
      width: 200px;
      height: 4px;
      background-color: $primary-color;
      animation: lrs-loading 2s linear infinite;
    }
  }

  @keyframes lrs-loading {
    from {
      left: -200px;
      width: 30%;
    }

    50% {
      width: 30%;
    }

    70% {
      width: 70%;
    }

    80% {
      left: 50%;
    }

    95% {
      left: 120%;
    }

    to {
      left: 100%;
    }
  }
</style>
